import { UseFormReturn } from "react-hook-form";
import { GeneralInformationPFFormData } from "@/components/individual-registration/schemas";
import { Form } from "@/components/ui/form";
import { FormBuilder } from "@/components/form-builder";
import { SectionDivider } from "./section-divider";
import { SettingsFooterActions } from "./settings-footer-actions";
import { personalInfoFields, addressFields, healthFields, bankFields } from "./pessoa-fisica-fields";

interface PessoaFisicaTabProps {
  form: UseFormReturn<GeneralInformationPFFormData>;
  onSave: () => void;
  onCancel: () => void;
  isSaving?: boolean;
}

export function PessoaFisicaTab({ form, onSave, onCancel, isSaving }: PessoaFisicaTabProps) {
  return (
    <div className="flex flex-col gap-4 w-full">
      {/* Pessoa Física Card */}
      <div className="bg-[#15203c] rounded-lg p-4 flex flex-col gap-5">
        {/* Section Title */}
        <div className="flex flex-col gap-0.5">
          <h2 className="font-['Plus_Jakarta_Sans'] font-bold text-xl text-white leading-normal">
            Pessoa Física
          </h2>
          <p className="font-['Plus_Jakarta_Sans'] font-normal text-xs text-[#d1d1d1] leading-normal">
            Atualize seus dados pessoais
          </p>
        </div>

        <Form {...form}>
          <div className="flex flex-col gap-8">
            <div className="flex flex-col gap-3">
              <SectionDivider title="dados pessoais" />
              <FormBuilder
                fields={personalInfoFields}
                layout={{ columns: 2, gap: "md" }}
                formInstance={form}
                onSubmit={async () => undefined}
                showSave={false}
              />
            </div>
            
            <div className="flex flex-col gap-3">
              <SectionDivider title="endereço" />
              <FormBuilder
                fields={addressFields}
                layout={{ columns: 2, gap: "md" }}
                formInstance={form}
                onSubmit={async () => undefined}
                showSave={false}
              />
            </div>

            <div className="flex flex-col gap-3">
              <SectionDivider title="saúde e prevenção" />
              <FormBuilder
                fields={healthFields}
                layout={{ columns: 2, gap: "md" }}
                formInstance={form}
                onSubmit={async () => undefined}
                showSave={false}
              />
            </div>

            <div className="flex flex-col gap-3">
              <SectionDivider title="dados bancários" />
              <FormBuilder
                fields={bankFields}
                layout={{ columns: 2, gap: "md" }}
                formInstance={form}
                onSubmit={async () => undefined}
                showSave={false}
              />
            </div>
          </div>
        </Form>
        <SettingsFooterActions onSave={onSave} onCancel={onCancel} isSaving={isSaving} />
      </div>
    </div>
  );
}
